import { forwardRef } from 'react'
import cx from 'classnames'

import './Card.css'

const Card = forwardRef(({ children, className = '', ...others }, ref) => {
  return (
    <div ref={ref} className={cx('card-wrapper', className)} {...others}>
      {children}
    </div>
  )
})

export default Card
